import React, { useEffect } from 'react';
import { useAuth } from '@/features/auth-managment/model/auth-context';
import { useCurrentLocale } from '@locales/client';

import { ItemAuth } from '../../styles';
import { BoxGoogleAuth } from './styles';

import { Box } from '@/shared/ui/box';

export const loadGoogleIdentityScript = () => {
  const script = document.createElement('script');
  script.src = 'https://accounts.google.com/gsi/client';
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
};

export const GoogleAuth = () => {
  const locale = useCurrentLocale();
  const { authenticationType } = useAuth();

  useEffect(() => {
    const removeScript = loadGoogleIdentityScript();
    return removeScript;
  }, []);

  const configData = {
    data_login_uri: `${window.location.origin}/google/${authenticationType !== 'signup' ? 'login' : 'register'}`,
    client_id: process.env.NEXT_PUBLIC_DATA_CLIENT_ID,
    data_text: authenticationType !== 'signup' ? 'signin' : 'signup_with',
  };

  return (
    <ItemAuth>
      <BoxGoogleAuth>
        <Box
          id="g_id_onload"
          data-client_id={configData.client_id}
          data-login_uri={configData.data_login_uri}
          data-auto_prompt="false"
        />
        <Box
          className="g_id_signin"
          data-type="standard"
          data-size="large"
          data-theme="filled_blue"
          data-shape="rectangular"
          data-logo_alignment="center"
          data-text={configData.data_text}
          data-locale={locale}
        />
      </BoxGoogleAuth>
    </ItemAuth>
  );
};
